import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

interface LookupItem {
    name: string;
    value?: string;
} // TODO, make this generic
@Component({
    selector: 'app-magic-multi-selector',
    templateUrl: './magic-multi-selector.component.html',
    styleUrls: ['./magic-multi-selector.component.scss'],
})
export class MagicMultiSelectorComponent implements OnInit {
    @Input() title: string;
    @Input() controller: FormControl = new FormControl();
    @Input() lookup: LookupItem[] = [];
    @Input() magicField: LookupItem | undefined;
    @Input() hint: string;
    constructor() {}

    ngOnInit(): void {}

    get controllerValue(): string[] {
        return this.controller.value || [];
    }
}
